const list = [
  {
    name: 'Dashboard',

    isCollapsible: false,

    open: false,

    link: '/dashboard',

    active: false,
  },

  {
    name: 'JewelAR',

    isCollapsible: true,

    open: false,

    active: false,

    subMenu: [
      {
        name: 'Category',

        subLink: '/category',

        count: 0,

        key: 'CATEGORY',
      },
      {
        name: 'Product',

        subLink: '/subcategory',

        count: 0,

        key: 'SUBCATEGORY',
      },
      {
        name: 'Sub Product',

        subLink: '/productstyle',

        count: 0,

        key: 'PRODUCT STYLE',
      },

      {
        name: 'Product Upload',

        subLink: '/product',

        count: 0,

        key: 'PRODUCT',
      },
      {
        name: 'Rate',

        subLink: '/rate',

        count: 0,

        key: 'RATE',
      },
      {
        name: 'Customer',

        subLink: '/customer',

        count: 0,

        key: 'CUSTOMER',
      },

      {
        name: 'Staff',

        subLink: '/staff',

        count: 0,

        key: 'STAFF',
      },
      // {
      //   name: 'Appointment',

      //   subLink: '/appointment',

      //   count: 0,

      //   key: 'APPOINTMENT',
      // },
      {
        name: 'Appointments',

        subLink: '/appointments',

        count: 0,

        key: 'APPOINTMENTS',
      },
      {
        name: 'Custom Request',

        subLink: '/customrequest',

        count: 0,

        key: 'customrequest',
      },
      {
        name: 'Contact Us list',

        subLink: '/contactuslist',

        count: 0,

        key: 'contactuslist',
      },
    ],
  },

  {
    name: 'Settings',

    isCollapsible: true,

    open: false,

    active: false,

    subMenu: [
      {
        name: 'Banner',

        subLink: '/banner',

        count: 0,

        key: 'BANNER LIST',
      },

      {
        name: 'Option list',

        subLink: '/optionlist',

        count: 0,

        key: 'OPTIONLIST',
      },
      {
        name: 'About',

        subLink: '/about',

        count: 0,

        key: 'ABOUT',
      },
      {
        name: 'Tryon',

        subLink: '/tryon',

        count: 0,

        key: 'TRYON',
      },
      {
        name: 'Store',

        subLink: '/store',

        count: 0,

        key: 'STORE',
      },
      {
        name: 'Testimonials',

        subLink: '/testimonial',

        count: 0,

        key: 'TESTIMONIAL',
      },
    ],
  },
]

export default list
